const notificationMessages = {
  rating: '🎉 Спасибо за вашу оценку!',
};

export default notificationMessages;
